module.exports = __webpack_public_path__ + "img/sparkling-steps.92a4e16e.webp";